module.exports = __webpack_public_path__ + "static/media/PATS_7-1690w.21d76887.webp";